import { Box, styled, SxProps, useTheme } from "@mui/material";
import * as React from "react";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { AssetTypeAlphaColor } from "../../../Utils/helpers";
import AssetIcon from "../AssetIcon/asset-icon";
import { hexToRgbString } from "../../../Utils/Helpers/cssUtils";

export type AssetThumbnailProps = {
  sx?: SxProps;
  className?: string;
  type: ObjectType;
  size?: "x-large" | "large" | "medium" | "small" | "micro" | "x-micro";
  translucent?: boolean;
};

const AssetThumbnail: React.FC<AssetThumbnailProps> = (props) => (
  <StyledBox {...props}>
    <AssetIcon type={props.type} />
  </StyledBox>
);

export default AssetThumbnail;

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "size" && prop !== "type" && prop !== "translucent",
})<{
  size?: AssetThumbnailProps["size"];
  type: ObjectType;
  translucent?: boolean;
}>(({ size, type, translucent }) => {
  let _size = 56;
  let _iconSize = 28;
  let _borderRadius = 6;
  switch (size) {
    case "x-large":
      _size = 96;
      _iconSize = 44;
      _borderRadius = 12;
      break;
    case "large":
      _size = 56;
      _iconSize = 28;
      _borderRadius = 8;
      break;
    case "medium":
      _size = 40;
      _iconSize = 20;
      _borderRadius = 6;
      break;
    case "small":
      _size = 32;
      _iconSize = 16;
      _borderRadius = 6;
      break;
    case "micro":
      _size = 20;
      _iconSize = 16;
      _borderRadius = 4;
      break;
    case "x-micro":
      _size = 16;
      _iconSize = 12;
      _borderRadius = 2;
      break;
  }

  const theme = useTheme();

  const color =
    theme.palette.mode === "dark"
      ? `radial-gradient(102.68% 102.68% at 102.68% 0%, ${AssetTypeAlphaColor(type, 0.8)} 0%,  ${AssetTypeAlphaColor(
          type,
          0.4
        )} 53.4%,  ${AssetTypeAlphaColor(type, 0.3)} 100%)`
      : `radial-gradient(102.68% 102.68% at 102.68% 0%, ${AssetTypeAlphaColor(type, 0.3)} 0%,  ${AssetTypeAlphaColor(
          type,
          0.6
        )} 53.4%,  ${AssetTypeAlphaColor(type, 0.8)} 100%)`;

  return {
    width: _size,
    height: _size,
    background: translucent ? "transparent" : theme.palette.background[300],
    backgroundImage: color,
    borderRadius: _borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ".MuiSvgIcon-root": {
      fontSize: _iconSize,
      color: theme.palette.absolute.white,
      opacity: 0.8,
    },
  };
});
